<template>
    <div
        class="flex justify-center items-center ml-1 relative z-20 w-fit"
        @mouseenter="showHint = true"
        @mouseleave="showHint = false"
    >
        <BaseSvg name="icon-info-circle" class="shrink-0"/>
        <HintTransition :name="direction" :hint-seen="showHint">
            {{ $t(text) }}
        </HintTransition>
    </div>
</template>

<script setup>
import {BaseSvg, HintTransition} from "@/Components";
import {ref} from "vue";

const showHint = ref(false);
const props = defineProps({
    text: {
        required: true,
        type: String,
    },
    direction: {
        type: String,
        required: false,
        default: 'fade-right',
    },
});
</script>
